export interface AuthValidation {
  status: string;
  mileage: number;
  reason?: string;
  isinside: boolean;
}

export interface AuthorizationResponse {
  id: string | null;
  checkOutDate: string;
  checkInDate: string;
  originCenterId: string;
  destinationCenterId: string;
  reason: string;
  reasonObservations: string | null;
  authorizer: any;
  driver: any;
  stockVehicle: any;
  observations: string | null;
}

export interface User {
  nis?: string;
  fullName: string;
  email: string;
  company?: string;
}

export interface Vehicle {
  vin: string;
  plateNumber: string;
  model: string;
  insurance: string;
  isInside: boolean;
  isRedPlate: boolean;
}

interface StatusType {
  value: string;
  viewValue: string;
}

export const statusType: StatusType[] = [
  {
    value: 'PENDING',
    viewValue: 'pending'
  },
  {
    value: 'APPROVED',
    viewValue: 'approved'
  },
  {
    value: 'DENIED',
    viewValue: 'denied'
  },
  {
    value: 'FINISHED',
    viewValue: 'finished'
  },
  {
    value: 'VALIDATED',
    viewValue: 'validated'
  }
];

export interface Authorizations {
  requestNumber?: string;
  id?: string;
  redPlateId?: string;
  userId?: string;
  petitioner: string;
  requestType: string;
  vehicle?: Vehicle;
  model: string;
  VIN: string;
  status: string;
  center: string;
  checked?: boolean;
  statusTranslation?: string;
}

export interface Vehicle {
  model: string;
  deliveryDate: string;
  plateNumber: string;
}

export enum AuthorizationType {
  REQUESTS = 'requests',
  TRANSFERS = 'transfers',
  RED_PLATES = 'redplates',
  JUDGEMENTS = 'judgements',
  ES = 'es'
}
